module.exports = __webpack_public_path__ + "img/missionaries32_2019_7-7-2021.03816a55.jpg";